import {
  Button,
  Checkbox,
  Col,
  Input,
  InputNumber,
  Popconfirm,
  Row,
  Tag,
} from "antd"
import { isNumber } from "lodash"
import NumberFormat from "react-number-format"

const UpdateApproved = (props, params, value) => {
  props.onEngQuotaBurnApproved({
    id: params.id,
  })
}
export const renderApprovedButton = (params, { props }) => {
  return (
    <Popconfirm
      title="در صورت تایید این مبلغ از کارکرد کارشناس کم میشود"
      description="آیا مطمئن هستید!؟"
      onConfirm={() => UpdateApproved(props, params, !params.approved)}
      okText="Yes"
      cancelText="No"
    >
      <Checkbox checked={params.approved}></Checkbox>
    </Popconfirm>
  )
}

// ----------------------------------------------------------

const UpdateInline = (props, params, pNam, e) => {
  let getValue = e.target.value
  if (pNam === "amountBurning")
    getValue = +e.target.value.replace(/\$\s?|(,*)/g, "") || 0
  if (params[pNam] !== getValue) {
    props.onEngQuotaBurnUpdate({
      id: params.id,
      des: pNam === "des" ? getValue : params.des,
      amountBurning:
        pNam === "amountBurning" ? getValue : params.amountBurning || 0,
    })
  }
}

export const renderAmountButton = (params, { props }) => {
  return (
    <InputNumber
      style={{ width: "100%" }}
      formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
      defaultValue={+params.amountBurning}
      width={100}
      min={0}
      onBlur={e => {
        UpdateInline(props, params, "amountBurning", e)
      }}
    />
  )
}

export const renderDesButton = (params, { props }) => {
  return (
    <Input.TextArea
      style={{ width: "100%" }}
      rows={1}
      defaultValue={params.des}
      width={100}
      onBlur={e => {
        UpdateInline(props, params, "des", e)
      }}
    />
  )
}

export const EngQuotaBurnColumnsAnt = props =>
  [

    {
      title: "سال/دوره",
      key: "period",
      render: params => (
        <div className="d-flex flex-column gap-2 justify-content-center align-items-center">
          <Tag color="blue">{params.quarterTariff.year}</Tag>
          <Tag color="blue">{params.quarterTariff.period}</Tag>
        </div>
      ),
      width: "3rem",
    },
    {
      title: "فصل",
      key: "period",
      render: params =>
        params.quarterTypeName + "-" + params.allotmentRoundTypeName,
      width: "7rem",
    },
    //fileNumber
    {
      title: "نام و نام خانوادگی",
      key: "k",
      render: params => params.engineer.fullName,
      width: "7rem",
    },
    {
      title: "مبلغ",
      key: "amountBurning",
      render: params => renderAmountButton(params, props),
      width: "8rem",
    },
    {
      title: "شماره پرونده",
      key: "fileNumber",
      render: params => (
        <div className="d-flex flex-column gap-2 justify-content-center align-items-center">
          <Tag color="blue">
            {params.gasProjectProcess?.gasProject?.fileNumber}
          </Tag>
          <Tag color="blue">{params.projectLevelName}</Tag>
        </div>
      ),
      width: "6rem",
    },
    {
      title: "توضیحات",
      key: "description",
      render: params => renderDesButton(params, props),
      width: "10rem",
    },
    {
      title: "تایید",
      key: "payByBankReceipt",
      render: params => renderApprovedButton(params, props),
      width: "3rem",
    },
    // {
    //   title: "جمع کل واریزی",
    //   key: "SumEngBalance",
    //   render : params => <NumberFormat
    //   displayType={"text"}
    //   value={params.sumEngBalance}
    //   thousandSeparator={true}
    // />
    // },
    // {
    //   title: "جمع کل مانده",
    //   key: "SumEngBalance",
    //   render : params => <NumberFormat
    //   displayType={"text"}
    //   value={params.sumEngBalance- params.sumAmountEngRealWorkThisQuarter - params.sumAmountEngRealWorkBefore}
    //   thousandSeparator={true}
    // />
    // }
  ].filter(item => !item.hidden)
